module.exports = "<ngx-chartjs [data]=\"chartData\" type=\"bar\" #chartjs></ngx-chartjs>\r\n"